import request from '@/utils/request'

// 查询shopee品牌1)业务定义：SHOPEE的品牌信息列表
export function listBrand(query) {
  return request({
    url: '/shopee/brand/list',
    method: 'get',
    params: query
  })
}

// 查询shopee品牌1)业务定义：SHOPEE的品牌信息详细
export function getBrand(brid) {
  return request({
    url: '/shopee/brand/' + brid,
    method: 'get'
  })
}

// 新增shopee品牌1)业务定义：SHOPEE的品牌信息
export function addBrand(data) {
  return request({
    url: '/shopee/brand',
    method: 'post',
    data: data
  })
}

// 修改shopee品牌1)业务定义：SHOPEE的品牌信息
export function updateBrand(data) {
  return request({
    url: '/shopee/brand',
    method: 'put',
    data: data
  })
}

// 删除shopee品牌1)业务定义：SHOPEE的品牌信息
export function delBrand(brid) {
  return request({
    url: '/shopee/brand/' + brid,
    method: 'delete'
  })
}

// 导出shopee品牌1)业务定义：SHOPEE的品牌信息
export function exportBrand(query) {
  return request({
    url: '/shopee/brand/export',
    method: 'get',
    params: query
  })
}

// 查询shopee品牌1)业务定义：SHOPEE的品牌信息列表
export function getList(query) {
    return request({
        url: '/shopee/brand/getList',
        method: 'get',
        params: query
    })
}